export const servicesData = [
  {
    id: 1,
    // src: require('assets/images/svg-1.svg'),
    src: require('assets/images/return.svg'),
    title: 'Reduce Expenses',
    paragraph: 'We help reduce your fess and increase your overall revenue'
  },
  {
    id: 2,
    src: require('assets/images/laptop.svg'),
    title: 'Virtual Offices',
    paragraph: 'You can access our platform online anywhere in the world'
  },
  {
    id: 3,
    // src: require('assets/images/svg-4.svg'),
    src: require('assets/images/protection.svg'),
    title: 'Premium Benefits',
    paragraph: 'Unlock our special membership card that returns 5$ cash back'
  }
];
